module.exports = __webpack_public_path__ + "img/logo_secondary-small-white.5f834b54.svg";